import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { LocalStorageService } from './localstorage.service';
import { Observable } from 'rxjs/Rx';
import { Router } from '@angular/router';
import { resolve } from 'dns';
import { rejects } from 'assert';

const TIME_OUT = 60000;

@Injectable()
export class GovDataService {
    org;  // 所选的组织架构
    findings; // 隐患的列表
    currentFindingIndex;   // 页面对应的是j
    
    // 2021/11/5 以下参数均没有被使用
    currentRegionIndex;    // 页面对应的是activeSegment
    currentSectionIndex;   // 页面对应的是k
    currentQuestionIndex;  // 页面对应的是i
    forms;
    currentForm;
    clickIndex;
    selectId;
    currentQuestion; // 当前问题
    currentFinding; // 当前选中的发现
    riskLevel;
    finding;
    inspectionObjectList;
    taskDetail;  // 计划检查任务详情数据
    selectForm; // 当前选中的表格 
    selectPlanForm;  // 计划检查选择的表格
    currentActionIndex;    // 页面对应的是r
    anchorPointIndex;    // 点击整改措施的锚点
    planFormsList;  // 计划检查所有的表格数据
    params; // 草稿页面路由参数
    isPlan = false;
    editable = false;
    checkType;
    draftData;
    
    public pageSize = 10;
    public initBasic = true;
    public pendding = 0;
    public todo = 0;
    public urlPrefix = this.localStorageService.getStore('API_DOMAIN') + this.localStorageService.getStore('API_DIR');
    public refresh = false;
    constructor(
        private http: HttpClient,
        public router: Router,
        public localStorageService: LocalStorageService) {
    }

    setData(para, data): any {
        this[para] = data;
    }

    getData(para): any {
        return this[para];
    }

    setMoreData(para, data): any  {
        para.forEach((element, index) => {
            this[element] = data[index];
        });
    }

    getMoreData(para): Promise<any> {
        const obj = {};
        para.forEach((element, index) => {
            obj[element] = this[element];
        });

        return new Promise((resolve, reject) => {
            obj ? resolve(obj) : reject(obj);
        });
    }

    clear() {
        const initialState = {
            org: null,
            findings: null,
            currentFindingIndex: null,
            currentRegionIndex: null,
            currentSectionIndex: null,
            currentQuestionIndex: null,
            forms: null,
            currentForm: null,
            clickIndex: null,
            selectId: null,
            currentQuestion: null,
            currentFinding: null,
            riskLevel: null,
            finding: null,
            inspectionObjectList: null,
            taskDetail: null,
            selectForm: null,
            selectPlanForm: null,
            currentActionIndex: null,
            anchorPointIndex: null,
            planFormsList: null,
            params: null,
            isPlan: false,
            editable: false,
            checkType: null,
            draftData: null,
            pageSize: 10,
            initBasic: true,
            pendding: 0,
            todo: 0,
            urlPrefix: this.localStorageService.getStore('API_DOMAIN') + this.localStorageService.getStore('API_DIR'),
            refresh: false
        };
        Object.keys(initialState).forEach((key) => {
            this[key] = initialState[key];
        });
    }    
}
